const constants = {
    URL: process.env.REACT_APP_URL || "https://ap-dev.sportforall.gov.ua/",
};

export default constants;